import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-social-facebook',
  templateUrl: './social-facebook.component.html'
})
export class SocialFacebookComponent {
  @Input() badgeWrapperSize: string = '50px';
  @Input() badgeIconSize: string = '30px';
  @Input() badgeStyleClass: string;
}
